import { CandidateRegistrationDtoClient } from "@/api/candidate/dto/candidate-registration.dto";
import { Role } from "@/api/enums/Role";
import { ValidationStatus } from "@/api/enums/ValidationStatus";
import { RegistrationUtil } from "@/lib/registration-util";

interface TransferWarningsProps {
  registration: CandidateRegistrationDtoClient;
  payer: Role;
}

const TransferWarnings = ({ registration, payer }: TransferWarningsProps) => {
  const paidByCandidate = payer === Role.CANDIDATE;

  return (
    <>
      {paidByCandidate &&
        RegistrationUtil.hasNonRefusedDelegation(registration) && (
          <p className="text-sm text-gray-500">
            La délégation sera refusée, comme lorsque le candidat paie lui-même.
          </p>
        )}
      {registration.reducedPriceStatus === ValidationStatus.PENDING && (
        <p className="text-sm text-orange-600">
          Le justificatif de tarif réduit est encore en attente : le tarif porté
          sur la facture peut être incorrect.
        </p>
      )}
      {RegistrationUtil.missingBillingAddress(registration, payer) && (
        <p className="text-sm text-gray-500">
          Cette inscription n'a pas d'adresse de facturation : renseignez-la
          ci-dessous pour que la facture puisse être générée.
        </p>
      )}
    </>
  );
};

export default TransferWarnings;
